import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';
import { CampanhaPipelineCardInfoReprovadaComponent } from './campanha-pipeline-card-info-reprovada.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        CampanhaPipelineCardInfoReprovadaComponent
    ],
    exports: [
        CampanhaPipelineCardInfoReprovadaComponent
    ]
})
export class CampanhaPipelineCardInfoReprovadaModule { }
